<div layout-vertical>
  <rt-label margin-bottom-small-xx>
    {{ 'rti.gfea.form.duplicate_jobs' | translate }}
    <rt-icon-help
      [rtTooltip]="'rti.gfea.form.duplicate_jobs_tooltip' | translate"
      margin-left-small-xx
    />
  </rt-label>

  @if (!!duplicateOfferIdsControl.value) {
    <div layout-vertical>
      <rt-toggle
        [checked]="true"
        [changeOnlyOnIconClick]="true"
        (valueChange)="openJobsDuplicationDialog()"
      >
        <div layout-horizontal layout-align-items-center>
          {{ 'rti.common.enabled' | translate }}
          <rt-icon name="edit" margin-left-small-x />
        </div>
      </rt-toggle>

      <rt-heading variant="large" margin-top margin-bottom-small>Einsatzorte</rt-heading>

      @for (
        positionLocationGroup of $any(positionLocationsArray.controls);
        track trackByPositionLocationGroup($index, positionLocationGroup);
        let first = $first
      ) {
        <div>
          @if (!first) {
            <rt-divider margin-tb />
          }

          <ng-container
            *ngTemplateOutlet="
              offerList;
              context: { offerIds: positionLocationGroup.value.offerIds }
            "
          />

          <rti-gfea-address-input [group]="$any(positionLocationGroup.controls).location" />
        </div>
      }
    </div>
  }

  @if (!duplicateOfferIdsControl.value) {
    <rt-toggle
      [checked]="false"
      [changeOnlyOnIconClick]="true"
      (valueChange)="openJobsDuplicationDialog()"
    >
      {{ 'rti.common.disabled' | translate }}
    </rt-toggle>
  }
</div>

<ng-template #offerList let-offerIds="offerIds">
  @for (offerId of offerIds; track trackByOfferId($index, offerId)) {
    <rt-box
      variant="no-padding no-border no-radius"
      layout-horizontal
      layout-align-items-center
      margin-bottom-small
      padding-small-x
    >
      <rt-offer-status-indicator
        [offerStatus]="$any(offerMap)[offerId]"
        margin-left-small
        margin-right-small
      />
      <div text-bold text-darkest>{{ offerMap[offerId].title }}</div>
      <div margin-left-small>{{ offerMap[offerId].city }}, {{ offerMap[offerId].countryCode }}</div>
    </rt-box>
  }
</ng-template>
